import React, { useState } from 'react'
import { Link } from '../global'
import './NewsletterSubscription.scss'

/**
 * React component for newsletter subscription.
 *
 * @component
 * @param {object} props - Component properties.
 * @param {string} props.version - The version of the newsletter component ('footer' or 'alternative').
 * @param {boolean} [props.isCta=false] - Indicates whether the component is used as a call-to-action.
 * @returns {JSX.Element} - React JSX element for newsletter subscription.
 */
export const NewsletterSubscription = props => {
  const [email, setEmail] = useState('')
  const [subscribed, setSubscribed] = useState(false)
  const [listType, setListType] = useState('byggframtid')
  const version = props.version
  const isCta = props.isCta || false

  const handleEmailChange = e => {
    setEmail(e.target.value)
  }

  const handleOptionChange = e => {
    setListType(e.target.value)
  }

  const endpoint = process.env.GATSBY_NEWSLETTER_API_URI + '/subscribe'
  const handleSubscribe = e => {
    e.preventDefault()
    if (!email) {
      // Email field is empty, don't make the request
      return
    }
    if (listType !== 'executive') {
      const requestData = { email: email, list_type: listType }
      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain',
        },
        body: JSON.stringify(requestData),
      }).then(response => {
        if (response.ok) {
          response.json().then(data => {
            setSubscribed(true)
          })
        }
      })
    }
  }

  const NewsletterContent = () => {
    if (subscribed === true) {
      return (
        <>
          <div class="successmessage newsletter-background">
            <h3>{'Tack för att du prenumererar!'}</h3>
          </div>
        </>
      )
    }

    switch (version) {
      case 'footer': {
        return (
          <>
            <h3>{'Prenumerera på vårat nyhetsbrev'}</h3>
            <label htmlFor="email">{'EMAIL'}</label>
            <input
              type="email"
              id="email"
              placeholder=""
              value={email}
              onChange={handleEmailChange}
            />
            <button className="button-link">{'PRENUMERERA'}</button>
          </>
        )
      }

      case 'alternative': {
        const radioBtnAlternatives = [
          { label: 'Byggframtid', value: 'byggframtid' },
          { label: 'Betongvärlden', value: 'betong' },
          { label: 'Arkitektvärlden', value: 'arkitekt' },
          { label: 'Executive Summary', value: 'executive' },
        ]
        const paragraph = isCta
          ? 'Anmäl dig till vårt nyhetsbrev och få nyhetsartiklar, fördjupande reportage, debattartikar och mycket mer direkt i din e-post varje torsdag.'
          : 'Prenumerera på vårt nyhetsbrev och håll dig uppdaterad om aktuellt från ByggFramtid'
        return (
          <div className="newsletter-background">
            <h3>{'Missa inget!'}</h3>
            <p>{paragraph}</p>
            <div className="radio-buttons">
              <div className={isCta ? 'isCta' : 'spacer'}>
                {radioBtnAlternatives.map((option, index) => (
                  <label key={index}>
                    <input
                      type="radio"
                      value={option.value}
                      checked={listType === option.value}
                      onChange={handleOptionChange}
                    />
                    {option.label}
                  </label>
                ))}
              </div>
            </div>
            {listType !== 'executive' && (
              <>
                <label>{'EMAIL'}</label>
                <input
                  type="email"
                  placeholder=""
                  value={email}
                  onChange={handleEmailChange}
                />
                <button className="button-link">{'PRENUMERERA'}</button>
              </>
            )}
            {listType === 'executive' && (
              <Link to={'/executive-summary'}>{'Executive Summary'}</Link>
            )}
          </div>
        )
      }
      default:
        return null
    }
  }

  return (
    <div className="newsletter-subscribe">
      <form onSubmit={handleSubscribe}>{NewsletterContent(version)}</form>
    </div>
  )
}
